import { ReactNode } from "react";

interface SectionProps {
  id: string;
  title: string;
  children: ReactNode;
  onSave?: () => void;
  isChanged?: boolean;
  isSaving?: boolean;
  disabled?: boolean;
}

export default function Section({
  id,
  title,
  children,
  onSave,
  isChanged = false,
  isSaving = false,
  disabled = false,
}: SectionProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" id={id}>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">{title}</h2>
        {onSave && (
          <button
            type="button"
            onClick={onSave}
            disabled={!isChanged || isSaving || disabled}
            className={`text-sm px-4 py-2 rounded-full transition ${
              isChanged && !isSaving && !disabled
                ? "bg-primary text-white hover:bg-primary-light"
                : "bg-gray-100 text-gray-400 cursor-not-allowed"
            }`}
          >
            {isSaving ? "Saving..." : "Save Changes"}
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
